import { createAction, props } from '@ngrx/store';

export const promptCallDialBegin = createAction(
   '[Recording New Prompt Hub] Prompt Call Dial Begin.',
   props<{ channelId: string; serverIp: string }>()
);

export const promptCallPickedUp = createAction(
   '[Recording New Prompt Hub] Prompt Call Picked Up.',
   props<{ channelId: string; serverIp: string }>()
);

export const recordingPrompt = createAction('[Recording New Prompt Hub] Recording Prompt.');

export const reviewingPrompt = createAction('[Recording New Prompt Hub] Reviewing Recorded Prompt.');

export const savingPrompt = createAction('[Recording New Prompt Hub] Saving Recorded Prompt.');

export const promptReady = createAction('[Recording New Prompt Hub] Prompt Ready.', props<{ promptId: number }>());

export const promptCallHungUp = createAction('[Recording New Prompt Hub] Prompt Call Hung Up.');
